import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-hot-toast";

export default function HotelUploadId() {
  const { guestId } = useParams();
  const navigate = useNavigate();

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const upload = async () => {
    if (files.length === 0) {
      toast.error("Select at least 1 ID image");
      return;
    }

    const fd = new FormData();
    files.forEach(f => fd.append("id_images[]", f));

    setLoading(true);

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/guest/upload-id/${guestId}`,
      {
        method: "POST",
        credentials: "include",
        body: fd,
      }
    );

    const data = await res.json();
    setLoading(false);

    if (data.status === "success") {
      toast.success("ID saved successfully ✅");
      navigate(-1);
    } else {
      toast.error(data.message || "Upload failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-6 rounded shadow w-80">
        <h2 className="font-bold mb-4 text-center">
          Upload Guest ID
        </h2>

        <input
          type="file"
          multiple
          accept="image/*"
          onChange={e => setFiles([...e.target.files])}
        />

        {files.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-3">
            {files.map((f, i) => (
              <img
                key={i}
                src={URL.createObjectURL(f)}
                className="w-16 h-16 object-cover rounded border"
              />
            ))}
          </div>
        )}

        <button
          onClick={upload}
          disabled={loading}
          className="mt-4 w-full bg-black text-white py-2 rounded"
        >
          {loading ? "Uploading..." : "Upload"}
        </button>
      </div>
    </div>
  );
}
